import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'ecp-map-info-card',
    templateUrl: './map-info-card.component.html',
    styleUrls: ['./map-info-card.component.css']
})
export class MapInfoCardComponent implements OnInit {
    @Input() ecpStyle: object = {};

    constructor() {
    }

    ngOnInit() {
    }

}
